<div class="re-container-headline re-mb-30 md:re-mb-45 lg:re-mb-60">
  <h3>
    {{ (isMove ? 'move.recentHome.title' : 'contract.end.recentHome.title') | translate }}
  </h3>
</div>

@if (!isMove) {
  <div class="re-container-with-margin re-mb-45 re-ml-20 md:re-mb-60 md:re-ml-auto">
    <div class="re-text-sm" bdoRouterLinkDirective bdoLinkTracking
      [trackingLocation]="trackingLocation"
      innerHTML="{{ 'contract.end.recentHome.description' | translate: { accountId: accountId, hrefHelpCenter: reBaseData.hrefHelpCenter } }}"
    ></div>
  </div>
}

<h4 class="re-container-with-margin re-mb-30 re-ml-20 md:re-mb-60 md:re-ml-auto">
  {{ (isMove ? 'move.recentHome.address.title' : 'contract.end.recentHome.address.title') | translate}}
</h4>

@if (accountId && address) {
  <div class="re-mb-15 re-bdo-tile">
    <bdo-accountid-with-address
      [accountId]="accountId"
      [address]="address"
    ></bdo-accountid-with-address>
  </div>
}

<form (ngSubmit)="save()" (keydown.enter)="$event.preventDefault()" [formGroup]="recentHomeForm" bdoScrollToInvalidControl [attr.aria-label]="'aria.form.recentHomeMeterReadings' | translate">
  <div class="re-bg-white re-w-full re-px-20 re-py-30 re-text re-mb-75
              md:re-w-600 md:re-mx-auto md:re-pb-60 md:re-mb-90
              lg:re-w-900">
    <div class="re-form-item-container re-mb-0">
      <div class="re-relative">
        @if (state === LoadingState.LOADING) {
          <bdo-loading></bdo-loading>
        }
      </div>

      <bdo-date-picker
        [noPreselection]="true"
        [selectedDate]="recentHomeForm?.get('moveoutDate').value"
        (dateSelected)="recentHomeForm?.get('moveoutDate').setValue($event)"
        [minDateForChanges]="minDate"
        [maxDateForChanges]="Utilities.maxDate"
        [labelText]="(isMove ? 'move.recentHome.address.endDate' : 'contract.end.recentHome.address.endDate') | translate"
        [requiredErrorText]="'move.recentHome.address.endDateRequired' | translate"
        [forceValidate]="forceValidate"
        [attr.data-qa_mindateforchanges]="minDate"
        [attr.data-qa_selecteddate]="recentHomeForm?.get('moveoutDate').value">
      </bdo-date-picker>

    </div>
  </div>

  <!-- Meterreadings for recent home-->
  <div class="re-container-with-margin re-mt-20 re-mb-45 re-ml-20 md:re-mb-60 md:re-ml-auto">
    <h4 class="re-mb-20 md:re-mb-30">
      {{ (isMove ? 'move.recentHome.meterreadings.title' : 'contract.end.recentHome.meterreadings.title') | translate }}
    </h4>
    <div class="re-text-sm"
      innerHTML="{{ (isMove ? 'move.recentHome.meterreadings.description' : 'contract.end.recentHome.meterreadings.description') | translate }}"
    ></div>
  </div>

  @if (stateRecentMeters === LoadingState.LOADING) {
    <div>
      <div class="re-bg-white re-w-full re-h-80 md:re-w-600 md:re-mx-auto lg:re-w-900"></div>
      <div class="re-bg-white re-w-full re-h-80 re-mb-20 md:re-w-600 md:re-mx-auto lg:re-w-900">
        <div class="re-relative">
          @if (stateRecentMeters === LoadingState.LOADING) {
            <bdo-loading></bdo-loading>
          }
        </div>
      </div>
    </div>
  }

  @for (division of divisions; track division) {
    <div>
      <h5 class="re-container-with-margin re-mb-20">
        {{ 'general.tariff.meterWithDivision' | translate: { division: division | verbrauchstyp } }}
      </h5>
      @for (meter of meters; track meter) {
        <div>
          @if (meter.sparte === division) {
            <div>
              <bdo-recent-meter-readings
                [meter]="meter"
                [parentForm]="recentHomeForm"
                (readingDataChange)="onReadingChange($event)"
                >
              </bdo-recent-meter-readings>
            </div>
          }
        </div>
      }
    </div>
  }


  <div class="re-w-full
              md:re-w-600 md:re-mx-auto
              lg:re-w-900">
    <div class="md:re-pl-0 re-pl-15">
      <bdo-validate-submit
        [isContextSummary]="context === CONTEXT_FROM_SUMMARY"
        [textButtonLong]="(isMove ? 'wizard.button.newHome' : 'wizard.button.payment') | translate"
      ></bdo-validate-submit>
      <div class="re-pt-15">
        <bdo-text-icon
          [iconPosition]="'left'"
          [text]="'general.action.back' | translate"
          (itemClicked)="location.back()"
        ></bdo-text-icon>
      </div>
    </div>
  </div>
</form>
